// StatsHeader.tsx
import React from 'react';
import { FaCoins, FaShieldAlt, FaUserSecret } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

interface StatsHeaderProps {
  tokens: number;
  totalDomains: number;
  totalSuspicious: number;
  onAddTokens?: () => void;
}

const StatsHeader: React.FC<StatsHeaderProps> = ({
  tokens,
  totalDomains,
  totalSuspicious
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
      {/* Tokens */}
      <div className="bg-gradient-to-b from-[#0A1723] to-[#050C12] text-white p-6 rounded-xl shadow flex flex-col items-center justify-center h-44">
        <FaCoins className="text-5xl mb-2" style={{ color: '#00FF69' }} />
        <p className="text-4xl font-bold">{tokens}</p>
        <span className="text-sm opacity-90 mt-1">
          {t('sienaguard.tokensAvailable')}
        </span>
      </div>

      {/* Dominios */}
      <div className="bg-gradient-to-b from-[#0A1723] to-[#050C12] text-white p-6 rounded-xl shadow flex flex-col items-center justify-center h-44">
        <FaShieldAlt className="text-5xl mb-2" style={{ color: '#00FF69' }} />
        <p className="text-4xl font-bold">{totalDomains}</p>
        <span className="text-sm opacity-90 mt-1">
          {t('sienaguard.monitoredDomains')}
        </span>
      </div>

      {/* Suplantaciones */}
      <div className="bg-gradient-to-b from-[#0A1723] to-[#050C12] text-white p-6 rounded-xl shadow flex flex-col items-center justify-center h-44">
        <FaUserSecret className="text-5xl mb-2" style={{ color: '#00FF69' }} />
        <p className="text-4xl font-bold">{totalSuspicious}</p>
        <span className="text-sm opacity-90 mt-1">
          {t('sienaguard.possibleImpersonations')}
        </span>
      </div>
    </div>
  );
};

export default StatsHeader;
